gameController = {};
//////////////////////////////////////////////////////
// New Spinner
gameController.dynamicSpinner = true;
//////////////////////////////////////////////////////
gameController.gameLoaded = false;
gameController.isPrePaid = false;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.onlyCaughtFish = false;
gameController.bonusSymbolsLanded = 0;
gameController.minBonusForFeature = 3;
gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.inBuyABonus = false;
gameController.inBuyABonusFirstSpin = true;
gameController.justHadFreeSpins = false;
gameController.spinTuneId = undefined;
gameController.idleTuneId = undefined;
gameController.reelspinId = 0;
gameController.symbolLandAnimator = undefined;
gameController.inRespin = false;
gameController.logoAnticipationSpin = false;
gameController.platformPaused = false;
gameController.platformPopupActive = false;
gameController.luckyBetToggled = false;
gameController.swipeShineTimer = undefined;

gameController.fishData = undefined;
gameController.maxPlayFishData = undefined;
gameController.fishermenAwards = undefined;
gameController.fishermenInView = undefined;
gameController.fullScreenBubblesBackground = undefined;
gameController.fullScreenSnowBackground = undefined;
gameController.symbolFramePanels = [];
gameController.fishCashOverlayAnimations = [];
gameController.canSkipWin = false;
gameController.winningsCountup = undefined;
gameController.inRecovery = false;
gameController.inBuyABonusRecovery = false;
gameController.mainAnticipationEmitters = [];
gameController.lastFishermanData = undefined;
gameController.fsWinnings = 0;
gameController.currentStake = 0;
gameController.muteCyclingWins = false;
gameController.finalFreeSpin = false;
gameController.skipWinsPressed = false;
gameController.totalWinnings = 0;
gameController.anticipating = false;
gameController.crtAnticipatingReel = 0;

gameController.idle = true;
gameController.savedReels = [];

gameController.currentAnticipationSound = undefined;
gameController.anticipationSounds = [
  "reelAnticipation1",
  "reelAnticipation2",
  "reelAnticipation3",
];
gameController.anticipationIndex = 0;

gameController.fishermanAnimsComplete = false;
gameController.landedFishermen = [];
gameController.newlyLocked = [];
gameController.allLockedFishermen = [];
gameController.previousLockedFishermen = [];
gameController.anchorLocks = 0;

gameController.bonusSymbolsToAnimate = [];
gameController.bonusSymbolsCurrent = [];
gameController.teaseStarted = false;

gameController.hookData = undefined;
gameController.finishedHooking = false;

gameController.respinData = undefined;
gameController.isRespinning = false;
gameController.hasRespun = false;
gameController.respunReels = undefined;
gameController.respunIndex = 0;
gameController.respinTask = undefined;
gameController.preRespinWinnings = 0;

gameController.meterOverlays = [];
gameController.meterOverlaysCreated = 0;
gameController.currentMeterOverlays = [];
gameController.cashOverlays = [];
gameController.cashOverlaysCreated = 0;
gameController.crtCashAnimations = [];
gameController.multiplierOverlays = [];
gameController.showMultipliers = false;
gameController.multiplierOverlaysCreated = 0;
gameController.currentMutlipliers = [];

gameController.wildOverlays = [];
gameController.wildOverlaysCreated = 0;
gameController.currentWilds = [];

gameController.fishermanEmitters = [];
gameController.crtFishermanEmitters = [];

gameController.animatedReelFish = false;

gameController.fishermenToReel = 0;
gameController.currentReelingIndex = 0;

gameController.boughtBonus = false;

gameController.finishedCatching = false;

gameController.winlineSounds = ["winline1", "winline2", "winline3"];
gameController.winlineSoundsIndex = 0;

gameController.gambleModeModes = ["five", "on", "off"];
gameController.gambleMode = "five";
gameController.gambleModeIndex = 0;

gameController.maxPlayActive = false;
gameController.inMaxPlay = false;
gameController.trailLevel = 1;
gameController.currentBand = "default";

gameController.multiplierAnim = undefined;
gameController.buyBonusStakeChanged = false;

gameController.lastBasicWin = undefined;
gameController.lastMaxPlayWin = undefined;
gameController.cycleWinDelayTimer = undefined;

gameController.switchGambleMode = function () {
  let len = gameController.gambleModeModes.length - 1;
  let temp = gameController.gambleModeIndex;
  temp++;

  if (temp < 0) {
    temp = len;
  } else if (temp > len) {
    temp = 0;
  }

  gameController.gambleModeIndex = temp;
  gameController.gambleMode = gameController.gambleModeModes[temp];

  return temp;
};

gameController.fadeSound = function (soundsToFade, fadeTo, time, fadeIn) {
  timerManager.addTimer(
    time,
    function (progress) {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          let fade = fadeTo * (1 - progress);
          if (fadeIn) {
            fade = fadeTo * progress;
          }
          soundManager.setVolume(fade, sound);
        }
      });
    },
    function () {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          soundManager.setVolume(fadeTo, sound);
        }
      });
    }
  );
};

gameController.initialise = function () {
  gameController.rng = new RNG();

  gameController.bigWin = resourceManager.get("bigWin");
  gameController.bigWin.init();

  autoplayManager.dialog.buttonGlow = resourceManager.get(
    "buttonContainer:buttonBar:autoplayButton:glow"
  );
  autoplayManager.dialog.buttonGlow.visible = false;

  const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");
  volumeButton.canShowBase = volumeButton.canShow;
  const canEnableSound = settingsMenu.buttons.btnSound.visible;
  volumeButton.canShow = function () {
    const soundButton = resourceManager.get(
      "systemSettings:systemSettingsBox:settingSound"
    );
    soundButton.setActive(canEnableSound);
    soundButton.alpha = canEnableSound ? 1 : 0.3;

    return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
  };

  gameController.setupSlotAnimVisuals();
  gameController.fullScreenBubblesFront =
    resourceManager.get("risingBubblesFront");
  gameController.fullScreenBubblesBack =
    resourceManager.get("risingBubblesBack");
  gameController.fullScreenBubblesBackground = resourceManager.get(
    "risingBubblesBackground"
  );

  const params = {
    scale: 0.2,
    startSpeed: 60,
    endSpeed: 40,
    lifetime: 5,
    frequency: 0.06,
    clear: true,
  };

  gameController.fullScreenBubblesBackground.overrideParams(params);
  gameController.fullScreenBubblesBackground.startBubbles();

  gameController.fullScreenSnowBackground = resourceManager.get(
    "fallingSnowBackground"
  );
  gameController.fullScreenSnowBackground.startSnow();

  gameController.slotMachine = resourceManager.getController("SlotMachine");

  const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4"];
  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);

    gameController.stoppedReels[reel] = true;
    gameController.onSpinLand(reel);
  });

  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.onSpinHit(reel);
  });

  for (let i = 0; i < 5; ++i) {
    let rv = resourceManager.get("slotContainer:reelContainer:reel" + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.slotMachine.selectReelMode("default");

  gameController.winlineAnimator =
    resourceManager.getSharedPlugin("WinlineAnimatorEx");

  const slamStopButton = resourceManager.get(
    "buttonContainer:buttonBar:slamStopButton"
  );
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return this.canEnableBase() && gameController._receivedResponse;
  };

  gameController.stakeController =
    resourceManager.getController("stakeController");

  gameController.symbolLandAnimator = resourceManager.get(
    "slotContainer:BonusLandAnimator"
  );

  gameController.winControllerMain =
    resourceManager.getController("WinControllerMain");

  gameController.freeSpinsTrailPanel = resourceManager.get(
    "freeSpinsTrailPanel"
  );

  gameController.respinsPopup = resourceManager.get(
    "respinsPopupContainer:respinsPopup"
  );

  gameController.winlinePopup = resourceManager.get("winlinePopupContainer");
  gameController.winlinePopup.visible = false;
  gameController.winlinePopupText = resourceManager.get(
    "winlinePopupContainer:linePays"
  );

  gameController.scatterSymbolReels = [];

  gameController.symbolAnimator = resourceManager.get(
    "slotContainer:SymbolAnimator"
  );

  gameController.reelDark = resourceManager.get("reelDarkContainer:reelDark");
  gameController.reelDark.beginFill(0x000000);
  gameController.reelDark.lineStyle(0, 0x000000);
  gameController.reelDark.drawRect(0, 0, 1, 1);
  gameController.reelDark.scale.x = 975;
  gameController.reelDark.scale.y = 480;
  gameController.reelDark.x = 132;
  gameController.reelDark.y = 186;
  gameController.reelDark.visible = false;

  gameController.slotMachine.setDynamicSpinner(true);

  gameController.createLogoSpine();
  gameController.createLogoSwipeShine();

  musicManager.onGameLoaded();

  Reflex.registerEventHandler("resize", gameController.onResize);

  gameController.timeScale = 1;
  document.addEventListener("keydown", gameController.onKeyDown);
};

gameController.createLogoSpine = function () {
  const contLandscape = resourceManager.get(
    "postReels:logoContainerLandscape:spineContainer"
  );

  gameController.logoLandscape = resourceManager.createObject(
    "spine",
    "LogoSpineLandscape",
    contLandscape,
    {
      name: "LogoSpine",
      defaultAnimation: "Logo Idle (LS)",
      scaleX: 1,
      scaleY: 1,
    }
  );

  gameController.logoLandscape.play("Logo Idle (LS)", true, 0, () => {});

  const contPortrait = resourceManager.get(
    "postReels:logoContainerPortrait:spineContainer"
  );

  gameController.logoPortrait = resourceManager.createObject(
    "spine",
    "LogoSpinePortrait",
    contPortrait,
    {
      name: "LogoSpine",
      defaultAnimation: "Logo Idle (Stacked)",
      scaleX: 1,
      scaleY: 1,
    }
  );

  gameController.logoPortrait.play("Logo Idle (Stacked)", true, 0, () => {});
};

gameController.createLogoSwipeShine = function () {
  const maskLandscape = resourceManager.get(
    "postReels:logoContainerLandscape:logoShine"
  );
  const swipeLandscape = resourceManager.get(
    "postReels:logoContainerLandscape:swipeShine"
  );
  const maskPortrait = resourceManager.get(
    "postReels:logoContainerPortrait:logoShine"
  );
  const swipePortrait = resourceManager.get(
    "postReels:logoContainerPortrait:swipeShine"
  );

  swipeLandscape.mask = maskLandscape;
  swipePortrait.mask = maskPortrait;

  const startLandscape = swipeLandscape.x;
  const startPortrait = swipePortrait.x;
  const goToLandscape = swipeLandscape.x + 160;
  const goToPortrait = swipePortrait.x + 520;

  gameController.swipeShineTimeline = gsap
    .timeline({ paused: true })
    .call(() => {
      swipeLandscape.x = startLandscape;
      swipePortrait.x = startPortrait;
    })
    .to(swipeLandscape, {
      duration: 1,
      x: goToLandscape,
    })
    .to(
      swipePortrait,
      {
        duration: 1,
        x: goToPortrait,
      },
      "<"
    );

  gameController.swipeShineLoop();
};

gameController.swipeShineLoop = function () {
  if (gameController.swipeShineTimer) {
    timerManager.stop(gameController.swipeShineTimer);
  }

  gameController.swipeShineTimer = timerManager.addTimeout(5000, () => {
    gameController.doSwipeShine();
  });
};

gameController.doSwipeShine = function () {
  gameController.swipeShineTimeline.play(0);

  if (gameController.idle) {
    gameController.swipeShineTimer = timerManager.addTimeout(5000, () => {
      gameController.doSwipeShine();
    });
  }
};

gameController.toggleReelDark = function (show, duration = 0.3, delay = 0) {
  if (show) {
    gameController.reelDark.visible = true;
    gameController.reelDark.alpha = 0;

    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0.5,
    });
  } else {
    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0,
      onComplete: () => {
        gameController.reelDark.visible = false;
      },
    });
  }
};

gameController.onKeyDown = function (event) {};

gameController.setTimeScale = function () {
  PIXI.ticker.shared.speed = gameController.timeScale;
  gsap.globalTimeline.timeScale(gameController.timeScale);
};

gameController.startReelAnticipation = function (reel) {
  gameController.anticipating = true;

  gameController.stopReelAnticipation();

  gameController.crtAnticipatingReel = reel;

  gameController.mainAnticipationEmitters[
    reel
  ].emitter.particleEmitter.emit = true;
  gameController.mainAnticipationEmitters[reel].emitter.visible = true;

  if (gameController.mainAnticipationEmitters[reel].timeline) {
    gameController.mainAnticipationEmitters[reel].timeline.restart();
  }
};

gameController.stopReelAnticipation = function (clear = false) {
  gameController.mainAnticipationEmitters.forEach((mainEmitter) => {
    if (clear) {
      mainEmitter.emitter.particleEmitter.cleanup();
    }

    mainEmitter.emitter.particleEmitter.emit = false;
    if (mainEmitter.timeline) {
      mainEmitter.timeline.pause();
    }
  });
};

gameController.setupSlotAnimVisuals = function () {
  for (var reel = 0; reel < 5; reel++) {
    var symbolFrames = [];

    for (var row = 0; row < 3; row++) {
      let pos = helpers.getSymbolPos(reel, row);

      var symbolFrame = resourceManager.createObject(
        "movie",
        "symbolFrame" + reel + "_" + row,
        "particlesContainerFront",
        {
          definition: "symbolFrame",
          x: pos.x,
          y: pos.y,
          anchor: 0.5,
          scale: 1.0,
          loop: false,
        }
      );
      symbolFrame.gotoAndStop(0);
      symbolFrames.push(symbolFrame);
    }
    gameController.symbolFramePanels.push(symbolFrames);
  }

  for (let i = 0; i < 5; i++) {
    let mainAnticipation = particleManager.createEmitter(
      "anticipation",
      "particlesContainerFront",
      0,
      0,
      false
    );
    mainAnticipation.particleEmitter.emit = false;
    mainAnticipation.visible = false;
    let mainAnticipationAnim = {
      emitter: mainAnticipation,
      timeline: undefined,
    };
    gameController.mainAnticipationEmitters.push(mainAnticipationAnim);
  }
  gameController.resetAnticipationEmitterPositions();
};

gameController.resetAnticipationEmitterPositions = function (clear = false) {
  gameController.stopReelAnticipation(clear);

  for (let i = 0; i < 5; i++) {
    const landscape = systemData.isLandscape;

    let xOffset = landscape ? 100 : 84;
    let yOffset = landscape ? 250 : 190;

    if (i < gameController.mainAnticipationEmitters.length) {
      let pos = helpers.getSymbolPos(i, 1);
      let mainEmitterSpawnPos = {
        x: pos.x + xOffset,
        y: pos.y - yOffset,
      };

      if (gameController.mainAnticipationEmitters[i].timeline) {
        gameController.mainAnticipationEmitters[i].timeline.clear();
      }

      gameController.mainAnticipationEmitters[i].timeline = gsap.timeline({
        repeat: -1,
        defaults: { ease: "none" },
        paused: true,
      });

      let mainObject = gameController.mainAnticipationEmitters[i].emitter;
      mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
      mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;

      gameController.mainAnticipationEmitters[i].timeline
        .to(mainEmitterSpawnPos, {
          x: pos.x + xOffset,
          y: pos.y + yOffset,
          duration: 0.3,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x - xOffset,
          y: pos.y + yOffset,
          duration: 0.1,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x - xOffset,
          y: pos.y - yOffset,
          duration: 0.3,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x + xOffset,
          y: pos.y - yOffset,
          duration: 0.1,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
          },
        });
    }
  }
};

gameController.fishermanLand = function (fishermen) {
  for (i = 0; i < fishermen.length; i++) {
    const coord = fishermen[i];
    const pos = helpers.getSymbolPos(coord.reel, coord.row);
    const emitter = gameController.getFishermanEmitter();

    const scale = resourceManager.get("slotContainer").scale;

    emitter.x = pos.x;
    emitter.y = pos.y;
    emitter.scale = scale;
    emitter.particleEmitter.emit = true;

    timerManager.addTimeout(500, () => {
      gameController.fishermanEmitters.push(emitter);
    });
  }
};

gameController.getFishermanEmitter = function () {
  let emitter = undefined;

  if (gameController.fishermanEmitters.length > 0) {
    emitter = gameController.fishermanEmitters.pop();
  } else {
    emitter = particleManager.createEmitter(
      "fishermanEmitter",
      "fishermenOverlayContainer",
      0,
      0,
      false
    );
  }

  gameController.crtFishermanEmitters.push(emitter);

  return emitter;
};

gameController.bonusTease = function () {
  if (gameData.reelsSpinning <= 0) return;

  //Not using animateSymbols callback because value gets cached and not updated
  timerManager.addTimeout(900, () => {
    gameController.bonusTease();
  });

  if (!gameController.slamStopped) {
    if (gameController.bonusSymbolsCurrent.length > 0) {
      gameController.symbolLandAnimator.animateSymbols(
        gameController.bonusSymbolsCurrent,
        gameController.slotMachine,
        true,
        false
      );
    }
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  gameController.slotMachine.clearHeldReels();
  gameController.previousLockedFishermen = gameController.allLockedFishermen;
  gameController.spinComplete = true;
  gameController.anticipating = false;
  gameController._receivedResponse = true;
  gameController.slamStopped = false;
  gameController.canSlamStop = false;
  gameData.reelsSpinning = 0;
  gameController.crtFishermanEmitters = [];

  gameData.recoveryStake = undefined;

  soundManager.stop("reelspin");

  gameController.resetAnticipationEmitterPositions(true);

  gameController.stateMachine.switchState("WAITING_FOR_REELS");
};

gameController.getFishData = function () {
  return gameController.maxPlayActive
    ? gameController.maxPlayFishData
    : gameController.fishData;
};

gameController.getFishSpinningPastData = function () {
  // return an object with absolute value to display on the fish
  // and the symbol id to display

  spinningFishData = {};
  let randomfish = Math.floor(Math.random() * 6);

  if (randomfish === 0) {
    spinningFishData = { value: 100, symbolId: 11 };
  } else if (randomfish === 1) {
    spinningFishData = { value: 300, symbolId: 10 };
  } else if (randomfish === 2) {
    spinningFishData = { value: 500, symbolId: 9 };
  } else if (randomfish === 3) {
    spinningFishData = { value: 800, symbolId: 8 };
  } else if (randomfish === 4) {
    spinningFishData = { value: 1500, symbolId: 7 };
  } else if (randomfish === 5) {
    spinningFishData = { value: 2500, symbolId: 6 };
  }
  return spinningFishData;
};

gameController.getIsRecovery = function () {
  return gameController.inRecovery;
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.isBonusPossible = function (reel) {
  switch (reel) {
    case 0: {
      return true;
    }
    case 1: {
      return gameController.bonusSymbolsLanded !== 0;
    }
    case 2: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 3: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 4: {
      return gameController.bonusSymbolsLanded >= 3;
    }
  }
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "FS") +
    gameController.countSymbolOnReel(reel, "FSS") +
    gameController.countSymbolOnReel(reel, "FSM")
  );
};

gameController.countLogoOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Logo");
};

gameController.onSpinHit = function (reel) {
  let symbolsToAnimate = [];
  let landedFishermen = [];
  let bonusSymbolFound = false;
  let results = gameController.isRespinning
    ? gameController.respinData.finalStopWindow
    : gameController.spinTask.data.resultPanel;
  let respun = true;

  if (gameController.isRespinning) {
    respun = gameController.respunReels.find((element) => element === reel);
  }

  for (let row = 0; row < results.reelList[reel].symbols.length; ++row) {
    const symbolValue = results.reelList[reel].symbols[row].value;

    if (symbolValue === 17) {
      let symData = {
        cell: { reel, row },
        symbolId: symbolValue,
      };
      if (respun !== undefined) {
        symbolsToAnimate.push(symData);
        bonusSymbolFound = true;
      } else {
        gameController.bonusSymbolsCurrent.push(symData);
      }
    }

    // Fisherman symbol
    if (
      symbolValue === 0 ||
      symbolValue === 33 ||
      symbolValue === 34 ||
      symbolValue === 35 ||
      symbolValue === 36
    ) {
      let symData = {
        cell: { reel, row },
        symbolId: symbolValue,
      };

      if (gameController.previousLockedFishermen.length === 0) {
        gameController.landedFishermen.push(symData.cell);
        gameController.checkNewlyLocked(symData.cell);

        if (respun !== undefined) {
          soundManager.play("fishermanLand");
          landedFishermen.push(symData.cell);
        }
      } else {
        let found = false;

        gameController.previousLockedFishermen.forEach((fisherman) => {
          const coord = fisherman.coord;

          if (
            coord.reel === symData.cell.reel &&
            coord.row === symData.cell.row
          ) {
            found = true;
          }
        });

        if (!found) {
          gameController.landedFishermen.push(symData.cell);
          gameController.checkNewlyLocked(symData.cell);

          if (respun !== undefined) {
            soundManager.play("fishermanLand");
            landedFishermen.push(symData.cell);
          }
        }
      }
    }
  }

  if (bonusSymbolFound) {
    let landIndex = gameController.bonusSymbolsLanded;
    if (landIndex >= 5) {
      landIndex = 4;
    }
    soundManager.play("bonusLand" + landIndex);
    gameController.bonusSymbolsLanded++;
  } else {
    soundManager.play("reelStop" + reel);
  }

  if (landedFishermen.length > 0) {
    gameController.fishermanLand(landedFishermen);
  }

  if (symbolsToAnimate.length > 0) {
    gameController.bonusSymbolsCurrent.push(symbolsToAnimate[0]);

    gameController.symbolLandAnimator.skip();

    if (gameController.slamStopped) {
      timerManager.addTimeout(5, () => {
        gameController.symbolLandAnimator.animateSymbols(
          symbolsToAnimate,
          gameController.slotMachine,
          true,
          false,
          () => {}
        );
      });
    } else {
      if (gameController.bonusSymbolsLanded > 1) {
        gameController.bonusTease();
      } else {
        gameController.symbolLandAnimator.animateSymbols(
          symbolsToAnimate,
          gameController.slotMachine,
          true,
          false,
          () => {}
        );
      }
    }
  }
};

gameController.onSpinLand = function (reel) {
  gameController.landedReels[reel] = true;

  let respun = true;

  if (gameController.isRespinning) {
    respun = gameController.respunReels.find((element) => element === reel);
  }

  gameData.reelsSpinning--;

  if (respun !== undefined) {
    gameController.respunIndex++;
  }

  if (gameController.isRespinning) {
    if (respun !== undefined) {
      let nextReel =
        gameController.respunReels[gameController.respunIndex] ?? undefined;

      const found = gameController.respunReels.find(
        (element) => element === nextReel
      );

      if (found) {
        if (spinController.longSpinMainReels[nextReel] === true) {
          gameController.startReelAnticipation(nextReel);
          if (!gameController.slamStopped) {
            gameController.currentAnticipationSound = soundManager.play(
              gameController.anticipationSounds[
                gameController.anticipationIndex
              ]
            );
            gameController.anticipationIndex++;
          }
        }
      }
    }
  } else {
    if (reel <= 3) {
      // Don't need to look ahead for the last reel
      let nextReel = reel + 1;
      if (spinController.longSpinMainReels[nextReel] === true) {
        gameController.startReelAnticipation(nextReel);

        if (
          gameController.slamStopped &&
          gameController.anticipationIndex === 0
        ) {
          gameController.currentAnticipationSound = soundManager.play(
            "reelAnticipationLong"
          );
        } else {
          if (!gameController.slamStopped) {
            gameController.currentAnticipationSound = soundManager.play(
              gameController.anticipationSounds[
                gameController.anticipationIndex
              ]
            );
          }
        }

        gameController.anticipationIndex++;
      }
    }
  }
};

gameController.checkNewlyLocked = function (cell) {
  gameController.allLockedFishermen.forEach((fisherman) => {
    const coord = fisherman.coord;

    if (coord.reel === cell.reel && coord.row === cell.row) {
      gameController.newlyLocked.push(cell);
      gameController.anchorLocks++;
    }
  });
};

gameController.onGameConfigEvent = function () {
  gameController.gameLoaded = true;
};

gameController.checkReels = function () {
  const resources = [
    resourceManager.get("preReels"),
    resourceManager.get("slotContainer"),
    resourceManager.get("postReels"),
    resourceManager.get("fishermenOverlayContainer"),
    resourceManager.get("fishermenMultiplierOverlayContainer"),
  ];

  resources.forEach((resource) => {
    resource.visible = true;
    resource.alpha = 1;
  });
};

gameController.doSpin = function (spinTask) {
  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameController.checkReels();

  gameController.hasRespun = false;
  gameController.anticipating = false;

  gameController.isPrePaid = spinTask.data.isPrePaidGame;

  gameController.idle = false;
  if (gameController.swipeShineTimer) {
    timerManager.stop(gameController.swipeShineTimer);
    gameController.swipeShineTimer = undefined;
  }

  gameController.bonusSymbolsCurrent = [];

  gameController.anticipationIndex = 0;

  gameController.preRespinWinnings = 0;

  gameController.resetMultiplierDim();

  if (gameController.maxPlayActive) {
    gameController.lastMaxPlayWin = undefined;
    gameController.maxPlayFishData = spinTask.data.fishData;
    gameController.applyOversizedSymbols(spinTask.data.fishData);
  } else {
    gameController.fishData = spinTask.data.fishData;
    gameController.applyOversizedSymbols(gameController.fishData);
    gameController.lastBasicWin = undefined;
  }

  gameController._receivedResponse = true;
  gameController.skipWinsPressed = false;
  gameController.respunReels = undefined;

  gameData.reelsSpinning = 5;

  gameController.longSpinReels = [false, false, false, false, false];

  gameController.finalFreeSpin = spinTask.data.finalFreeSpin;
  gameController.allLockedFishermen = spinTask.data.lockedFishermen;

  gameController.hookData = spinTask.data.hookData ?? { isAwarded: false };

  gameController.respinData = spinTask.data.respinData ?? { isAwarded: false };

  if (gameController.inBuyABonus && gameController.inBuyABonusFirstSpin) {
    gameController.longSpinReels = [false, false, true, false, true];
    gameController.inBuyABonusFirstSpin = false;
  }

  if (spinTask.data.localRng) {
    gameController.rng.seed(spinTask.data.localRng);
  }

  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (
      let row = 0;
      row < spinTask.data.resultPanel.reelList[reel].symbols.length;
      row++
    ) {
      symbols[reel].push(
        spinTask.data.resultPanel.reelList[reel].symbols[row].value
      );
    }
  }

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();

  gameController.fishermenAwards = spinTask.data.fishermenAwards;
  gameController.fishermenInView = spinTask.data.fishermenInView;

  spinController.stopSpin(symbols, above, below, gameController.onSpinComplete);
};

gameController.doRespin = function (spinTask) {
  if (gameController.maxPlayActive) {
    gameController.maxPlayFishData = spinTask.newfish;
    gameController.applyOversizedSymbols(spinTask.newfish);
  } else {
    gameController.getNewFishData(spinTask.respunReels, spinTask.newfish);
    gameController.applyOversizedSymbols(gameController.fishData);
  }

  gameController.canSlamStop = true;
  gameController.slamStopped = false;
  messageBus.postImmediate("respin");

  gameController.hasRespun = true;
  gameController.lastPayWinsData = undefined;

  gameController.currentReelSpin = soundManager.play("reelSpin");
  gameController.anticipationIndex = 0;

  if (gameController.dynamicSpinner) {
    spinController.startSpin(spinTask.respunReels);
  } else {
    gameController.slotMachine.infiniteSpin();
  }

  gameController.isRespinning = true;
  gameController.respunIndex = 0;

  gameController.slotMachine.dimAllSymbols(false, 0.1);

  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameController._receivedResponse = true;
  gameController.skipWinsPressed = false;

  gameData.reelsSpinning = 5;
  gameController.bonusTease();

  gameController.longSpinReels = [false, false, false, false, false];

  gameController.hookData = { isAwarded: false };

  gameController.returnCashOverlay();

  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.finalStopWindow.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (
      let row = 0;
      row < spinTask.finalStopWindow.reelList[reel].symbols.length;
      row++
    ) {
      symbols[reel].push(
        spinTask.finalStopWindow.reelList[reel].symbols[row].value
      );
    }
  }

  gameController.fishermenAwards = spinTask.fishermenAwards;
  gameController.respunReels = spinTask.respunReels;

  gameController.doRespinAnticipation(spinTask);

  spinController.stopSpin(symbols, above, below, () => {
    gameController.onSpinComplete();
    gameController.respinData = { isAwarded: false };
  });
};

gameController.applyOversizedSymbols = function (data) {
  const oversizedId = 5;

  data.forEach((fish) => {
    if (fish.symbol === oversizedId) {
      const reel = gameData.reels[fish.coord.reel];
      const cont = reel.parent;
      cont.setChildIndex(reel, cont.children.length - 1);
    }
  });
};

gameController.doRespinAnticipation = function (spinTask) {
  if (gameController.slamStopped) return;

  for (let i = 0; i < spinTask.respunReels.length; ++i) {
    const int = spinTask.respunReels[i];

    if (i === 0) {
      gameController.startReelAnticipation(int);
    }
  }

  gameController.currentAnticipationSound = soundManager.play(
    "reelAnticipationLong"
  );
  gameController.anticipationIndex++;
};

gameController.getNewFishData = function (respun, newFish) {
  let temp = [];

  gameController.fishData.forEach((fish) => {
    const reel = fish.coord.reel;

    const found = respun.find((r) => r === reel);

    if (found === undefined) {
      temp.push(fish);
    }
  });

  gameController.fishData = temp;

  gameController.fishData.push(...newFish);
};

gameController.initNewSpin = function () {
  musicManager.onGameStart();

  gameController.returnCashOverlay();

  let bandType = undefined;

  if (gameController.inFreeSpins) {
    bandType = "freeSpins" + gameController.trailLevel;
  } else if (gameController.maxPlayActive) {
    bandType = "maxPlay";
  } else {
    bandType = "default";
  }

  if (bandType !== gameController.currentBand) {
    gameController.currentBand = bandType;
    gameController.slotMachine.switchReelBand(bandType);
    gameController.slotMachine.setDynamicSpinner(true);
  }

  if (gameController.inFreeSpins) {
    gameController.canSlamStop = true;
  } else {
    gameController.canSlamStop = false;
    timerManager.addTimeout(750, () => {
      gameController.canSlamStop = true;
    });

    gameController.lastFishermanData = undefined;
  }

  if (gameController.lastFishermanData !== undefined) {
    let fishermanPos = gameController.lastFishermanData.pos;
    let reel = gameController.lastFishermanData.reel;
    gameController.animateMultiplierIncrease(fishermanPos, reel);
    gameController.lastFishermanData = undefined;
  }

  gameController._receivedResponse = false;

  gameController.landedFishermen = [];
  gameController.newlyLocked = [];
  gameController.crtFishermanEmitters = [];

  gameController.slamStopped = false;
  gameController.bonusSymbolsLanded = 0;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  gameData.winningsText.skip();
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;

  if (!gameController.inFreeSpins) {
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
  }

  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }

  gameController.currentReelSpin = soundManager.play("reelSpin");
  gameController.symbolAnimator.skip();
  gameController.symbolLandAnimator.skip();

  gameController.stoppedReels = [false, false, false, false, false];
  gameController.landedReels = [false, false, false, false, false];

  if (gameController.dynamicSpinner) {
    spinController.startSpin();
  } else {
    gameController.slotMachine.infiniteSpin();
  }

  gameController.slotMachine.dimAllSymbols(false, 0.1);

  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;
};

gameController.initNewGame = function () {
  gameController.stopCyclingWins();
  gameController.muteCyclingWins = false;

  gameController.inBuyABonus = false;
  gameController.inBuyABonusFirstSpin = true;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");

  gameController.initNewSpin();

  if (autoplayManager.isAutoplayEnabled()) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds() - 1)
      );
  }
};

gameController.startGame = function () {
  // Do not allow the user to spin if the buy bonus or autoplay dialog is visible
  let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");
  let autoplayPopUp = resourceManager.get("autoplayContainer:autoplayBacker");

  if (buyBonusPopUp.visible || autoplayPopUp.visible) return;

  gameController.justHadFreeSpins = false;

  gameController.initNewGame();
  let bpl =
    gameController.stakeController.BaseStake /
    gameController.stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: gameController.stakeController.CurrentStake,
      numWinlines: gameController.stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
        gambleMode: gameController.gambleModeIndex,
        maxPlay: gameController.maxPlayActive,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.stopCyclingWins = function () {
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.lastPayWinsData = undefined;
  gameController.winlineAnimator.skipAnimation();
  gameController.winlineAnimator.clearWinlines();
  gameController.cyclingWinsIndex = 0;

  if (gameController.cycleWinDelayTimer) {
    timerManager.stop(gameController.cycleWinDelayTimer);
    gameController.cycleWinDelayTimer = undefined;
  }

  gameController.stopSymbolFrameDisplay();
  gameController.winlinePopup.visible = false;
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (gameController.isRespinning) {
    gameController.respinTask.leave();
    gameController.respinTask = undefined;
    gameController.isRespinning = false;
  }

  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.checkForSymbolOnFullReels = function (symbol) {
  for (let reel = 0; reel < 5; reel++) {
    for (let row = 0; row < 3; row++) {
      if (
        gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
          .value === symbol
      ) {
        return true;
      }
    }
  }
  return false;
};

gameController.autoplayStarted = function (autoplayData) {
  autoplayManager.dialog.buttonGlow.visible = true;
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setText("autoplayCancelButton", "");

  autoplayManager.dialog.buttonGlow.visible = false;
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  autoplayManager.stopAutoplay();
  resourceManager.getController("autoplayController").cancel();
  gameController.stoppingAutoplay = true;

  autoplayManager.dialog.buttonGlow.visible = false;
};

gameController.stateMachine.addState("WAITING_FOR_REELS", function () {
  if (gameController.phase.hold()) {
    if (gameController.spinComplete) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    gameController.stateMachine.switchState("WAITING_FOR_BONUSES");
  }
});

gameController.stateMachine.addState("WAITING_FOR_BONUSES", function () {
  if (gameController.phase.once()) {
    if (gameController.inFreeSpins || gameController.maxPlayActive) {
      gameController.finishedCatching = false;
      gameController.catchFish(function () {
        gameController.finishedCatching = true;
      });
    } else {
      gameController.finishedCatching = true;
    }
  }
  if (gameController.phase.hold()) {
    if (gameController.finishedCatching) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    gameController.bonusSymbolsToAnimate = [];

    gameController.getMainReelBonusAnimations();

    if (!gameController.inFreeSpins && gameController.hookData.isAwarded) {
      gameController.finishedHooking = false;

      messageBus.post("startHook", {
        data: {
          currentSymbols: gameController.bonusSymbolsToAnimate,
          hook: gameController.hookData,
        },
      });
    } else {
      gameController.finishedHooking = true;
    }
  }
  if (gameController.phase.hold()) {
    if (gameController.finishedHooking) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    if (
      gameController.bonusSymbolsLanded >= 3 ||
      gameController.hookData.isAwarded
    ) {
      gameController.displayBonusEntryAnims();
    } else {
      gameController.setState_WaitingForServer(gameController.spinTask);
    }
  }
});

gameController.getHookedSymbols = function () {
  for (i = 0; i < gameController.hookData.newScatters.length; i++) {
    const coord = gameController.hookData.newScatters[i];
    let symData = {
      cell: { reel: coord.reel, row: coord.row },
      symbolId: 17,
    };
    gameController.bonusSymbolsToAnimate.push(symData);
  }
};

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.once()) {
    resourceManager.getController("inputOverlord").setState("enabled");
    resourceManager.getController("autoplayController").checkLimits();
  }

  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (
      !autoplayManager.isAutoplayEnabled() &&
      !(gameController.justHadFreeSpins || musicManager.wasInFreeSpins)
    ) {
      gameController.cyclingWins = true;
      gameController.cycleWins();
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (
        autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
        autoplayManager.AP.roundsRemaining()
      ) {
        var timeToNext = 500;
        resourceManager.getController("autoplayController").timeToNextAutoplay =
          timeToNext;
        gameController.phase.step();
      }
    }
  }

  if (
    gameController.phase.timed(
      resourceManager.getController("autoplayController").timeToNextAutoplay
    )
  ) {
  }

  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();

    soundManager.play("winCountUp");
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = true;
      }

      gameController.unFadeSymbols();

      gameController.stateMachine.switchState("DELAY_SHOW_WINNINGS");

      soundManager.stop("winCountUp");
      soundManager.play("winCountUpEnd");
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible =
          gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_PLAYING", function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState("GAME_ENDED", function () {
  if (gameController.phase.enter()) {
    gameController.canSkipWin = false;
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
        gameData.mainTunePlaying = true;
      }
      gameController.stateMachine.switchState("WAITING_FOR_START");
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.displayBonusEntryAnims = function () {
  musicManager.onFreeSpinsWon();

  if (gameController.hookData.isAwarded) {
    gameController.getHookedSymbols();
  }

  if (gameController.bonusSymbolsToAnimate.length > 2) {
    gameController.symbolLandAnimator.skip();
    gameController.symbolLandAnimator.animateSymbols(
      gameController.bonusSymbolsToAnimate,
      gameController.slotMachine,
      function () {},
      true
    );
  }

  timerManager.addTimeout(1000, function () {
    gameController.setState_WaitingForServer(gameController.spinTask);
  });
};

gameController.getMainReelBonusAnimations = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    for (let j = 0; j < 3; ++j) {
      const sym = reel.getReelSymbol(j);

      if (sym === 17) {
        const symData = {
          cell: { reel: i, row: j },
          symbolId: 17,
        };
        gameController.bonusSymbolsToAnimate.push(symData);
      }
    }
  }
};

gameController.resetMultiplierDim = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    reel.resetMultipliers();
  }
};

gameController.resetHideMultipliers = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    reel.showMultiplier(true);
  }
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (
      gameController.lastPayWinsData !== undefined &&
      gameController.lastPayWinsData.winningLines?.length > 0
    ) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWin();
    }
  }
};

gameController.cycleWin = function () {
  let canCelebrate =
    this.lastPayWinsData.totalLineWinnings >
    gameController.stakeController.CurrentStake;

  if (gameController.lastPayWinsData.winningLines.length !== 0) {
    gameController.symbolAnimating = true;

    let data =
      gameController.lastPayWinsData.winningLines[
        gameController.cyclingWinsIndex
      ];

    gameController.winlinePopup.visible = true;

    gameController.winlinePopupText.setTranslationParameters(
      data.winningLine,
      gdk.formatCurrency(data.winAmount)
    );

    soundManager.play(
      gameController.winlineSounds[gameController.winlineSoundsIndex]
    );

    gameController.winlineSoundsIndex++;

    if (
      gameController.winlineSoundsIndex >= gameController.winlineSounds.length
    ) {
      gameController.winlineSoundsIndex = 0;
    }

    let symbols = [];

    for (let i = 0; i < data.positions.length; ++i) {
      symbols.push({
        cell: { reel: data.positions[i].reel, row: data.positions[i].row },
        symbolId: data.symbol.ids[i],
      });
    }

    if (canCelebrate) {
      gameController.symbolAnimator.animateSymbols(
        symbols,
        gameController.slotMachine,
        canCelebrate,
        false,
        function () {}
      );
    }

    gameController.cycleWinDelay();

    let frameData = {
      winningLines: [
        gameController.lastPayWinsData.winningLines[
          gameController.cyclingWinsIndex
        ],
      ],
    };

    gameController.displaySymbolFrames(frameData);

    gameController.animating = true;

    gameController.winlineAnimator.playAnimations(
      [
        gameController.lastPayWinsData.winningLines[
          gameController.cyclingWinsIndex
        ],
      ],
      function () {
        gameController.animating = false;
        gameController.symbolAnimating = false;
      },
      true,
      false
    );
  }
};

gameController.setWinningsText = function (finalCount = false) {
  const currentStake = gameController.stakeController.getBaseStake();

  let winnings = gameController.lastPayWinsData.totalLineWinnings;

  if (gameController.respinData.isAwarded && gameController.hasRespun) {
    winnings =
      gameController.lastPayWinsData.totalLineWinnings +
      gameController.preRespinWinnings;
  }

  if (
    finalCount ||
    gameController.lastPayWinsData.totalLineWinnings < currentStake * 5 ||
    gameController.skipWinsPressed
  ) {
    gameData.winningsText.setText(winnings);
  } else {
    soundManager.play("winCountUp");

    const obj = { amount: 0 };
    gameController.winningsCountup = gsap.to(obj, {
      duration: 0.9,
      amount: winnings,
      onUpdate: () => {
        gameData.winningsText.setText(obj.amount);
      },
      onComplete: () => {
        soundManager.stop("winCountUp");
        soundManager.play("winCountUpEnd");
        gameController.winningsCountup = undefined;
      },
    });
  }
};

gameController.cycleWinDelay = function () {
  gameController.cycleWinDelayTimer = timerManager.addTimer(
    1800,
    undefined,
    function () {
      gameController.symbolAnimating = false;
      gameController.cycleNextWin();
    }
  );
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    if (
      gameController.cyclingWinsIndex <
      gameController.lastPayWinsData.winningLines.length - 1
    ) {
      gameController.cyclingWinsIndex++;
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  }

  gameController.muteCyclingWins = true;
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

gameController.onStakeChanged = function (stake) {
  if (gameData.recoveryStake) return;

  const currentStake = gameData.stakes[gameData.currentStakeIndex];
  gameData.stakeMeter.set(stake);

  if (currentStake !== stake) {
    gameData.currentStakeIndex = gameData.stakes.indexOf(stake);
    game.changeStake(stake);
    gameController.currentStake = stake;

    if (!gameController.luckyBetToggled) {
      gameController.stopCyclingWins();
      gameData.winningsMeter.set(0);
      gameController.returnCashOverlay();
    }

    gameController.luckyBetToggled = false;

    const goldenText = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetTextStake"
    );
    goldenText.setTranslationParameters(gdk.formatCurrency(stake));
  }
};

gameController.getCurrentModeStake = function () {
  let stake = 0;

  if (gameController.stakeController) {
    stake = gameController.stakeController.getBaseStake();

    if (gameController.inBuyABonus || gameController.boughtBonus) {
      stake = gameController.stakeController.getCurrentStake("BONUS_BUY");
    }
  }
  return stake;
};

gameController.onGameComplete = function () {
  if (gameController.inBuyABonus) {
    gameController.stakeController.broadcastCurrentStake("default");
  }

  gameController.inBuyABonus = false;
  gameController.idle = true;
  gameController.canSkipWin = false;

  gameController.swipeShineLoop();

  if (!gameController.inRecovery && !gameController.isPrePaid) {
    gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  }

  gdk.endGame(function () {
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");

      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }

    if (!musicManager.wasInFreeSpins) {
      musicManager.onGameEnd();
    } else {
      musicManager.wasInFreeSpins = false;
    }
  });
};

gameController.doSlamStop = function () {
  gameController.slamStopped = true;

  if (gameController.anticipating) {
    if (gameController.currentAnticipationSound !== undefined) {
      soundManager.stop(gameController.currentAnticipationSound);
    }
  }

  if (gameData.reelsSpinning > 0) {
    let crtBonus = 0;
    gameController.reelsToSlam = [];

    for (let i = 0; i < gameData.reels.length; ++i) {
      if (gameController.inFreeSpins || gameController.anticipating) {
        gameController.reelsToSlam.push(i);
      } else {
        const symbols =
          gameController.spinTask.data.resultPanel.reelList[i].symbols;

        if (crtBonus < 2) {
          gameController.reelsToSlam.push(i);
        } else {
          gameController.slamStopped = false;
          gameController.canSlamStop = true;
          messageBus.postImmediate("secondSlam");
        }

        for (let j = 0; j < symbols.length; j++) {
          if (symbols[j].value === 17) {
            crtBonus++;
          }
        }
      }
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);
  }
};

gameController.getRandomBezierPoint = function (
  startPoint,
  endPoint,
  distanceScaler,
  direction
) {
  // pass in undefined for unneeded parameters and it will pick a hopefully sensible default value
  // distanceScaler - (0.0 - 1.0) - Distance to move the bezier point away from the line - 0.0 = no movement, 1.0 = full line distance
  if (distanceScaler === undefined) {
    distanceScaler = 0.25; // Default to 25% of the line distance
  } else {
    // Clamp the distance scaler to 0.0 - 1.0
    distanceScaler = Math.min(1.0, Math.max(0.0, distanceScaler));
  }
  // direction - (0 or 1) - direction to move the bezier point - 0 = right, 1 = left
  // from the perspective of the line direction, stood at start point looking at end point
  if (direction !== 0 && direction !== 1) {
    direction = Math.floor(Math.random() * 2);
  }

  const midPoint = {
    x: (startPoint.x + endPoint.x) / 2,
    y: (startPoint.y + endPoint.y) / 2,
  };
  const directionVector = {
    x: endPoint.x - startPoint.x,
    y: endPoint.y - startPoint.y,
  };
  const mainLineMagnitude = Math.sqrt(
    directionVector.x ** 2 + directionVector.y ** 2
  );
  const distance = mainLineMagnitude * distanceScaler;
  const perpendicularVector = { x: -directionVector.y, y: directionVector.x };
  const perpendicularMagnitude = Math.sqrt(
    perpendicularVector.x ** 2 + perpendicularVector.y ** 2
  );
  perpendicularVector.x /= perpendicularMagnitude;
  perpendicularVector.y /= perpendicularMagnitude;
  const scaledPerpendicularVector = {
    x: perpendicularVector.x * distance,
    y: perpendicularVector.y * distance,
  };

  let xPos;
  let yPos;

  if (direction === 0) {
    xPos = midPoint.x + scaledPerpendicularVector.x;
    yPos = midPoint.y + scaledPerpendicularVector.y;
  } else {
    xPos = midPoint.x - scaledPerpendicularVector.x;
    yPos = midPoint.y - scaledPerpendicularVector.y;
  }

  const bezierPoint = { x: xPos, y: yPos };
  return bezierPoint;
};

gameController.calculateMagnitude = function (startPos, endPos) {
  const deltaX = endPos.x - startPos.x;
  const deltaY = endPos.y - startPos.y;
  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
};

gameController.calculateQuadraticBezierPosition = function (t, P0, P1, P2) {
  let x =
    Math.pow(1 - t, 2) * P0.x + 2 * (1 - t) * t * P1.x + Math.pow(t, 2) * P2.x;
  let y =
    Math.pow(1 - t, 2) * P0.y + 2 * (1 - t) * t * P1.y + Math.pow(t, 2) * P2.y;
  return { x: x, y: y };
};

gameController.doPayWins = function (winTask) {
  gameController.canSkipWin = true;
  gameController.canSlamStop = false;
  gameController.onlyCaughtFish = false;

  gameController.addWildToFishermen(winTask);
  gameController.toggleMultiplierVisible(false);

  if (
    winTask.data.totalLineWinnings > 0 &&
    winTask.data.winningLines.length === 0
  ) {
    gameController.onlyCaughtFish = true;
  }

  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();

  gameController.reelsPrize = winTask.data.totalLineWinnings;

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
    gameData.winningsMeter.add(gameController.winTask.data.totalLineWinnings);
    gameController.totalWinnings +=
      gameController.winTask.data.totalLineWinnings;
  }

  let stake = gameController.stakeController.CurrentStake;

  if (gameController.winTask.data.totalLineWinnings > stake) {
    gameController.doSwipeShine();

    gameController.logoLandscape.play("Logo Win (LS)", false, 0, () => {
      gameController.logoLandscape.play("Logo Idle (LS)", true, 0, () => {});
    });
    gameController.logoPortrait.play("Logo Win (Stacked)", false, 0, () => {
      gameController.logoPortrait.play(
        "Logo Idle (Stacked)",
        true,
        0,
        () => {}
      );
    });

    musicManager.stepUp();
  }

  gameController.lastPayWinsData = winTask.data;

  if (!gameController.inFreeSpins) {
    if (gameController.maxPlayActive) {
      gameController.lastMaxPlayWin = gameController.lastPayWinsData;
    } else {
      gameController.lastBasicWin = gameController.lastPayWinsData;
    }
  }

  if (gameController.respinData.isAwarded && !gameController.hasRespun) {
    gameController.preRespinWinnings = winTask.data.totalLineWinnings;
  }

  if (gameController.onlyCaughtFish) {
    timerManager.addTimeout(200, () => {
      gameController.winlinePreAnimsDone();
    });
  } else {
    timerManager.addTimeout(1, function () {
      gameController.dimNoneWinningSymbols(winTask.data.winningLines);

      if (gameController.winTask.data.totalLineWinnings >= stake) {
        gameController.winControllerMain.startAnimations(
          gameController.winTask.data,
          gameController.stakeController.CurrentStake,
          gameController.slotMachine,
          function () {
            gameController.winlinePreAnimsDone();
          }
        );
      } else {
        soundManager.play("lowerThanStakeWin");

        timerManager.addTimeout(200, () => {
          gameController.winlinePreAnimsDone();
        });
      }

      gameController.displaySymbolFrames(gameController.winTask.data);
    });
  }
};

gameController.addWildToFishermen = function (winTask) {
  const offsetX = 35;
  const offsetY = -45;
  const winningLines = winTask.data.winningLines;
  let winningFishermen = [];

  for (let i = 0; i < winningLines.length; i++) {
    const symbols = winningLines[i].symbol.ids;

    for (let j = 0; j < symbols.length; j++) {
      if (symbols[j] === 0) {
        const coord = winningLines[i].positions[j];

        winningFishermen.push(coord);
      }
    }
  }

  for (let i = 0; i < winningFishermen.length; i++) {
    const coord = winningFishermen[i];
    const overlay = gameController.getWildOverlay();
    const fishermanPos = helpers.getSymbolPos(coord.reel, coord.row);

    const scale = resourceManager.get("slotContainer").scale;
    const reel = resourceManager.get(
      "slotContainer:reelContainer:reel" + coord.reel
    );

    reel.showMultiplier(false);

    overlay.scale = scale;
    overlay.x = fishermanPos.x + offsetX * scale.x;
    overlay.y = fishermanPos.y + offsetY * scale.x;
    overlay.visible = true;

    gameController.currentWilds.push({
      overlay,
      coord,
      xPos: offsetX,
      yPos: offsetY,
    });
  }
};

gameController.returnAllWilds = function () {
  gameController.currentWilds.forEach((wild) => {
    gameController.wildOverlays.push(wild.overlay);
    wild.overlay.visible = false;
  });
  gameController.currentWilds = [];
};

gameController.getWildOverlay = function () {
  let overlay = undefined;

  if (gameController.wildOverlays.length > 0) {
    overlay = gameController.wildOverlays.pop();
  } else {
    overlay = resourceManager.createObject(
      "sprite",
      "wildOverlay" + gameController.wildOverlaysCreated,
      "fishermenWildOverlayContainer",
      {
        fileName: "Symbols/wild_text.png",
        anchor: 0.5,
      }
    );
    gameController.wildOverlaysCreated++;
  }

  return overlay;
};

gameController.displaySymbolFrames = function (data) {
  let symbols = new Set();

  for (let i = 0; i < data.winningLines.length; i++) {
    for (let j = 0; j < data.winningLines[i].positions.length; j++) {
      const symbol = JSON.stringify({
        reel: data.winningLines[i].positions[j].reel,
        row: data.winningLines[i].positions[j].row,
      });
      symbols.add(symbol);
    }
  }

  for (let i = 0; i < symbols.size; i++) {
    const sym = JSON.parse(Array.from(symbols)[i]);
    let mainReelScaleX = resourceManager.get("slotContainer").scale.x;
    let mainReelScaleY = resourceManager.get("slotContainer").scale.y;
    gameController.symbolFramePanels[sym.reel][sym.row].scale.set(
      mainReelScaleX,
      mainReelScaleY
    );

    const pos = helpers.getSymbolPos(sym.reel, sym.row);
    gameController.symbolFramePanels[sym.reel][sym.row].x = pos.x;
    gameController.symbolFramePanels[sym.reel][sym.row].y = pos.y;
    gameController.symbolFramePanels[sym.reel][sym.row].gotoAndStop(0);
    gameController.symbolFramePanels[sym.reel][sym.row].visible = true;
    gameController.symbolFramePanels[sym.reel][sym.row].play();
  }
};

gameController.stopSymbolFrameDisplay = function () {
  for (let i = 0; i < 5; i++) {
    for (let j = 0; j < 3; j++) {
      gameController.symbolFramePanels[i][j].visible = false;
      gameController.symbolFramePanels[i][j].gotoAndStop(0);
    }
  }
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  // dim none winning symbols
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * 5 + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < 5; ++reel) {
    for (let row = 0; row < 3; ++row) {
      if (winningPositions.indexOf(reel * 5 + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.winlinePreAnimsDone = function () {
  if (!gameController.winTask.data.isCapped) {
    gameController.setWinningsText();
    gameData.winningsText.animate(true, false);
  } else {
    gameController.setWinningsText();
    gameData.winningsText.animate(false, false);
  }

  gameData.winningsText.show(true, 0);

  timerManager.addTimeout(1000, function () {
    gameController.doBigWin();
    gameController.toggleMultiplierVisible(true);
    gameController.returnAllWilds();
    gameController.resetHideMultipliers();
  });
};

gameController.doBigWin = function () {
  let winnings =
    gameController.lastPayWinsData.totalLineWinnings +
    gameController.preRespinWinnings;
  let isBigWin = gameController.bigWin.willTriggerBigWin(winnings);
  let respinDontBigWin = false;

  if (gameController.respinData.isAwarded) {
    if (!gameController.hasRespun) {
      respinDontBigWin = true;
    }
  }

  if (isBigWin && !gameController.inFreeSpins && !respinDontBigWin) {
    gameController.bigWin.start(
      winnings,
      function () {
        gameController.bigWinDone();
      },
      gameController.winTask.data.isCapped
    );
  } else {
    gameController.bigWinDone();
  }
};

gameController.bigWinDone = function () {
  resourceManager.getContainer("DemoContainer").visible = true;

  if (gameController.inFreeSpins) {
    gameData.winningsMeter.countUp(
      gameController.lastPayWinsData.totalLineWinnings,
      1500
    );
    gameController.totalWinnings +=
      gameController.lastPayWinsData.totalLineWinnings;
  }

  gameController.bigWinFinished = true;

  gameController.winlineAnimsDone();
};

gameController.winlineAnimsDone = function () {
  gameController.slotMachine.clearDimSymbolIds();
  gameController.slotMachine.dimAllSymbols(false, 0.1);
  gameController.setWinningsText(true);
  gameData.winningsText.show(true, 0);
  gameData.winningsText.animateOut();

  gameController.canSkipWin = false;

  gameController.winlineAnimator.clearWinlines();

  gameController.winTask.leave();
  gameController.winTask = undefined;
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  gameController.skipWinsPressed = true;
  gameController.canSkipWin = false;

  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
  }

  if (gameController.winningsCountup !== undefined) {
    gameController.winningsCountup.progress(1);
    gameController.winningsCountup = undefined;
  }

  gameController.setWinningsText(true);

  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
};

gameController.returnCashOverlay = function () {
  gameController.currentMeterOverlays.forEach((overlay) => {
    overlay.overlay.frame.visible = false;
    overlay.overlay.cash.visible = false;

    gameController.meterOverlays.push(overlay.overlay);
  });

  gameController.currentMeterOverlays = [];
};

gameController.getCashOverlay = function () {
  let overlay = undefined;

  if (gameController.cashOverlays.length > 0) {
    overlay = gameController.cashOverlays.pop();
  } else {
    overlay = resourceManager.createObject(
      "text",
      "cashOverlay" + gameController.cashOverlaysCreated,
      "particlesContainerFront",
      {
        text: gdk.formatCurrency(0),
        anchor: 0.5,
        fontDefinition: "cashFish",
        maxWidth: 140,
        anchor: 0.5,
      }
    );
    gameController.cashOverlaysCreated++;
  }
  return overlay;
};

gameController.getMultiplierOverlay = function () {
  let overlay = undefined;

  if (gameController.multiplierOverlays.length > 0) {
    overlay = gameController.multiplierOverlays.pop();
  } else {
    overlay = resourceManager.createObject(
      "text",
      "multiplierOverlay" + gameController.multiplierOverlaysCreated,
      "fishermenMultiplierOverlayContainer",
      {
        text: "x2",
        anchor: 0.5,
        fontDefinition: "fishermanMultiplier",
        anchor: 0.5,
      }
    );
    gameController.multiplierOverlaysCreated++;
  }
  return overlay;
};

gameController.getMeterOverlay = function () {
  let overlay = undefined;

  if (gameController.meterOverlays.length > 0) {
    overlay = gameController.meterOverlays.pop();
  } else {
    frame = resourceManager.createObject(
      "sprite",
      "meterBackground" + gameController.meterOverlaysCreated,
      "fishermenOverlayContainer",
      { fileName: "Base_Game/TH_Fisherman_Meter.png", anchor: 0.5, alpha: 1 }
    );

    cash = resourceManager.createObject(
      "meter",
      "meterOverlay" + gameController.meterOverlaysCreated,
      "fishermenOverlayContainer",
      {
        initialValue: 0,
        anchor: 0.5,
        fontDefinition: "cashFish",
        maxWidth: 140,
        anchor: 0.5,
      }
    );

    overlay = { frame, cash };
    gameController.meterOverlaysCreated++;
  }
  return overlay;
};

gameController.reelInFish = function (cb) {
  soundManager.play("winAmountCountUp");
  soundManager.play("reelInFish");

  const fishWin =
    gameController.fishermenAwards.fish[gameController.currentReelingIndex];
  const fishermanCoord = fishWin.collectCoord;
  const fishermanPos = helpers.getSymbolPos(
    fishermanCoord.reel,
    fishermanCoord.row
  );
  const fishes = fishWin.fishs;
  const win = fishWin.winAmountBeforeMultiplier;
  const winMultipled = fishWin.winAmount;
  const multiplierAmount = fishWin.multiplier;
  const fishermanOffset = 55;
  const cashOffset = 60;
  const capped = fishWin.winCapped;
  const capAmount = gameController.globalHelperGetBaseStake() * 5000;

  const fishermanOverlay = gameController.getMeterOverlay();
  const fishermanCash = fishermanOverlay.cash;
  const fishermanFrame = fishermanOverlay.frame;
  const scale = resourceManager.get("slotContainer").scale;

  fishermanCash.x = fishermanPos.x;
  fishermanCash.y = fishermanPos.y + fishermanOffset * scale.x;
  fishermanCash.set(0);
  fishermanCash.visible = true;
  fishermanCash.scale = scale;

  fishermanFrame.x = fishermanPos.x;
  fishermanFrame.y = fishermanPos.y + fishermanOffset * scale.x;
  fishermanFrame.visible = true;
  fishermanFrame.scale = scale;

  gameController.currentMeterOverlays.push({
    overlay: fishermanOverlay,
    coord: fishermanCoord,
    yOffset: fishermanOffset,
  });

  const duration = 0.9;
  const delayInt = 0.3;
  let delay = 0;

  const len = fishes.length;

  fishermanCash.countUp(
    Math.min(capAmount, win),
    (duration + delayInt * len) * 1000,
    () => {
      soundManager.stop("winAmountCountUp");
      soundManager.play("winAmountCountUpEnd");
    }
  );

  const symData = {
    cell: fishermanCoord,
    symbolId: 0,
  };
  const symbols = [symData];
  gameController.symbolAnimator.animateSymbols(
    symbols,
    gameController.slotMachine,
    true,
    false,
    function () {}
  );

  let symbolsToAnimate = [];

  gameController.crtCashAnimations = [];

  for (let i = 0; i < len; i++) {
    const fish = fishes[i];
    const coord = fish.coord;
    const fishOverlay = gameController.getCashOverlay();
    const pos = helpers.getSymbolPos(coord.reel, coord.row);
    fishOverlay.x = pos.x;
    fishOverlay.y = pos.y + cashOffset * scale.x;
    fishOverlay.text = gdk.formatCurrency(fish.amount);
    fishOverlay.visible = true;
    fishOverlay.scale = scale;

    const fishReel = resourceManager.get(
      "slotContainer:reelContainer:reel" + coord.reel
    );
    const sym = fishReel.getReelSymbol(coord.row);
    const symData = {
      cell: coord,
      symbolId: sym,
    };

    if (symData !== undefined) {
      symbolsToAnimate.push(symData);
    }

    const reel = resourceManager.get(
      "slotContainer:reelContainer:reel" + fishermanCoord.reel
    );

    const anim = gsap.to(fishOverlay, {
      duration,
      delay,
      x: fishermanPos.x,
      y: fishermanPos.y + fishermanOffset * scale.x,
      ease: "linear",
      onComplete: () => {
        gameController.cashOverlays.push(fishOverlay);
        fishOverlay.visible = false;

        if (i === fishes.length - 1) {
          timerManager.addTimeout(800, function () {
            const multiply = multiplierAmount > 1;
            const timer = multiply ? 1100 : 1;

            if (!capped) {
              if (multiply) {
                soundManager.play("fishermanMultiplier");
                gameController.addMultiplier(0.5);
                fishermanCash.countUp(winMultipled - win, 0.8 * 1000);
                reel.dimMultiplier(fishermanCoord.row);
              } else {
                fishermanCash.set(winMultipled);
              }
            }

            timerManager.addTimeout(timer, function () {
              gameController.currentReelingIndex++;

              if (
                gameController.currentReelingIndex >=
                gameController.fishermenToReel
              ) {
                gameController.returnAllMultipliers();
                gameController.crtCashAnimations = [];
                cb();
              } else {
                gameController.reelInFish(cb);
              }
            });
          });
        }
      },
    });

    gameController.crtCashAnimations.push(anim);
    delay += delayInt;
  }

  if (!gameController.animatedReelFish && symbolsToAnimate.length > 0) {
    gameController.symbolAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      true,
      false,
      () => {}
    );
    gameController.animatedReelFish = true;
  }
};

gameController.catchFish = function (cb) {
  gameController.returnAllMultipliers();

  gameController.returnCashOverlay();

  let fishermanArray = gameController.inFreeSpins
    ? gameController.fishermenInView
    : gameController.fishermenAwards;

  if (fishermanArray.length === 0) {
    cb();
    return;
  }

  const scale = resourceManager.get("slotContainer").scale;

  for (let i = 0; i < fishermanArray.length; i++) {
    const fisherman = fishermanArray[i];
    const multi = fisherman.multiplier;

    if (multi > 1) {
      const coord = fisherman.coord;
      const fishermanPos = helpers.getSymbolPos(coord.reel, coord.row);
      const offsetX = 42;
      const offsetY = -45;

      const multiplier = this.getMultiplierOverlay();
      multiplier.text = "x" + multi;
      multiplier.x = fishermanPos.x + offsetX * scale.x;
      multiplier.y = fishermanPos.y + offsetY * scale.x;
      multiplier.visible = true;
      multiplier.scale = scale;

      gameController.currentMutlipliers.push({
        multiplier,
        coord,
        xPos: offsetX,
        yPos: offsetY,
      });
    }
  }

  if (gameController.fishermenAwards.winAmount === 0) {
    cb();
    return;
  }

  if (gameController.inFreeSpins) {
    gameController.fishermenInView.forEach((fisherman) => {
      const reel = fisherman.coord.reel;
      const row = fisherman.coord.row;
      const reelObj = resourceManager.get(
        "slotContainer:reelContainer:reel" + reel
      );

      let newSym = 0;
      switch (fisherman.multiplier) {
        case 2:
          newSym = 33;
          break;

        case 3:
          newSym = 34;
          break;

        case 5:
          newSym = 35;
          break;

        case 10:
          newSym = 36;
          break;
      }

      reelObj.setReelSymbol(row, newSym);
    });
  }

  let timer = 1;

  if (gameController.allLockedFishermen.length === 0) {
    messageBus.post("freeSpins:removeLocks");
  }

  if (gameController.anchorLocks > 0) {
    timer = 1200;
  }

  gameController.anchorLocks = 0;

  gameController.cashOverlays = [];
  gameController.currentReelingIndex = 0;
  gameController.fishermenToReel = gameController.fishermenAwards.fish.length;

  timerManager.addTimeout(timer, () => {
    gameController.animatedReelFish = false;
    gameController.reelInFish(cb);
  });
};

gameController.addMultiplier = function (duration = 0.6) {
  const multi = gameController.currentMutlipliers.shift().multiplier;
  const startX = multi.x;
  const startY = multi.y;

  gameController.multiplierAnim = gsap
    .timeline()
    .to(multi, {
      duration,
      x: startX - 40,
      y: startY + 80,
      ease: "power1.in",
    })
    .to(
      multi.scale,
      {
        duration,
        x: 0,
        y: 0,
        ease: "back.in(4)",
        onComplete: () => {
          gameController.multiplierOverlays.push(multi);
          multi.visible = false;

          gameController.multiplierAnim = undefined;
        },
      },
      "<"
    );
};

gameController.returnAllMultipliers = function () {
  gameController.currentMutlipliers.forEach((multi) => {
    gameController.multiplierOverlays.push(multi.multiplier);
    multi.multiplier.visible = false;
  });
  gameController.currentMutlipliers = [];
};

gameController.toggleMultiplierVisible = function (show) {
  gameController.showMultipliers = show;
  gameController.currentMutlipliers.forEach((multi) => {
    multi.multiplier.visible = show;
  });
};

gameController.hookComplete = function () {
  gameController.finishedHooking = true;
};

gameController.onRespinData = function (task) {
  task.join();

  gameController.respinTask = task;

  gameController.canSkipWin = false;

  gameController.respinsPopup.showPopup(() => {
    gameController.doRespin(gameController.respinData);
  });
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = function () {
  gameController.cancelAutoplay();
  gameController.inFreeSpins = true;
  gameController.inMaxPlay = false;
};

gameController.onFreespinsEnd = function () {
  gameController.returnAllMultipliers();
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
  gameController.anchorLocks = 0;

  if (gameController.buyBonusStakeChanged) {
    gameData.winningsMeter.set(0);
    gameController.buyBonusStakeChanged = false;
  }
};

gameController.swapAnchorToRod = function () {
  gameController.allLockedFishermen.forEach((fisherman) => {
    const coord = fisherman.coord;
    const reelObj = resourceManager.get(
      "slotContainer:reelContainer:reel" + coord.reel
    );
    reelObj.setReelSymbol(coord.row, 0);
  });
};

gameController.onFeatureStart = function (task) {};

gameController.globalHelperGetStake = function () {
  let stake = gameData.stakes[gameData.currentStakeIndex];
  if (gameController.boughtBonus) {
    stake = gameController.stakeController.getBaseStake("BONUS_BUY") * 125;
  } else if (gameData.currentStakeIndex === -1) {
    stake = gameController.currentStake;
  }
  return stake;
};

gameController.globalHelperGetBaseStake = function () {
  if (!gameController.gameLoaded) {
    return;
  }

  return gameController.stakeController.getBaseStake();
};

gameController.recoverGame = function (task) {
  if (task.data.clientParams?.Params) {
    const mode = task.data.clientParams.Params.mode;

    const gambleModeButton = resourceManager.get(
      "buttonContainer:buttonBar:gambleModeButton"
    );
    gambleModeButton.switchMode(mode);
    gameController.gambleMode = gameController.gambleModeModes[mode];
    gameController.gambleModeIndex = mode;
  }

  if (task.data.metaData == "lucky" || task.data.metaData == "lucky_max") {
    gameData.encoreEnabled = true;

    const encoreButtonLB = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );
    encoreButtonLB.setRecovery();
  }

  if (task.data.clientParams?.Params?.maxplay) {
    gameController.maxPlayActive = false;
    gameController.inMaxPlay = false;

    messageBus.postImmediate("maxPlay:RecoverGame");

    const maxPlayButton = resourceManager.get(
      "buttonContainer:buttonBar:maxPlayButton"
    );
    maxPlayButton.switchMode();
  }

  resourceManager.get("helpPageScrollContainer:helpPageScroll").close();

  gameController.inRecovery = true;

  if (task.data.metaData === "buyABonusFreeSpins" && task.data.metaValue) {
    gameController.inBuyABonus = true;
    gameController.inBuyABonusRecovery = true;
    gameController.initNewSpin();
  } else {
    musicManager.onGameStart();
    gameController.initNewSpin();
  }

  gameController.recoveryStake();
};

gameController.readyToStart = function () {
  if (gameController.inRecovery) {
    gameController.inRecovery = false;
  }
};

gameController.recoveryStake = function () {
  if (gameController.stakeController === undefined) return;

  let baseStake = gameController.stakeController.BaseStake;

  if (gameData.buyBonus) {
    baseStake = gameController.stakeController.getBaseStake("BONUS_BUY");
  } else if (gameData.encoreEnabled) {
    gameController.stakeController.setStakeMultiplier(1.5);
    baseStake = gameData.recoveryStake;
  }
  game.changeStake(baseStake);
};

gameController.onAbortGame = function () {
  gameController.slotMachine.abortSpin();

  if (gameController.maxPlayActive) {
    messageBus.postImmediate("maxPlay:DefaultReels");
  } else {
    Loader.setStartingSymbols();
  }
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cycleWins();
};

gameController.onResize = function () {
  let autoPlayButtonVisibility = resourceManager.get(
    "buttonContainer:buttonBar:autoplayButton"
  ).visible;
  if (!autoPlayButtonVisibility) {
    autoplayManager.dialog.buttonGlow.visible = false;
  }

  gameController.crtFishermanEmitters.forEach((emitter) => {
    emitter.particleEmitter.emit = false;
    emitter.particleEmitter.cleanup();
  });

  const scale = resourceManager.get("slotContainer").scale;

  gameController.crtCashAnimations.forEach((anim) => {
    if (anim.progress() < 1) {
      anim.progress(1);
    }
  });

  gameController.multiplierAnim?.progress(1);

  for (let i = 0; i < gameController.symbolFramePanels.length; i++) {
    const reel = gameController.symbolFramePanels[i];

    for (let j = 0; j < reel.length; j++) {
      const row = reel[j];
      const pos = helpers.getSymbolPos(i, j);

      row.x = pos.x;
      row.y = pos.y;
      row.scale = scale;
    }
  }

  gameController.reelDark.scale.x = 975;
  gameController.reelDark.scale.y = 480;
  gameController.reelDark.x = 132;
  gameController.reelDark.y = 186;

  gameController.currentMutlipliers.forEach((multi) => {
    const pos = helpers.getSymbolPos(multi.coord.reel, multi.coord.row);
    multi.multiplier.x = pos.x + multi.xPos * scale.x;
    multi.multiplier.y = pos.y + multi.yPos * scale.x;
    multi.multiplier.scale = scale;
  });

  gameController.currentWilds.forEach((wild) => {
    const pos = helpers.getSymbolPos(wild.coord.reel, wild.coord.row);
    wild.overlay.x = pos.x + wild.xPos * scale.x;
    wild.overlay.y = pos.y + wild.yPos * scale.x;
    wild.overlay.scale = scale;
  });

  gameController.currentMeterOverlays.forEach((overlay) => {
    const pos = helpers.getSymbolPos(overlay.coord.reel, overlay.coord.row);
    overlay.overlay.cash.x = pos.x;
    overlay.overlay.cash.y = pos.y + overlay.yOffset * scale.x;
    overlay.overlay.cash.scale = scale;
    overlay.overlay.frame.x = pos.x;
    overlay.overlay.frame.y = pos.y + overlay.yOffset * scale.x;
    overlay.overlay.frame.scale = scale;
  });
};

gameController.onLayoutChange = function () {
  gameController.resetAnticipationEmitterPositions(true);

  if (gameController.anticipating) {
    gameController.startReelAnticipation(gameController.crtAnticipatingReel);
  }
};

gameController.saveReels = function () {
  gameController.savedReels = [];

  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    const rowList = [];

    for (let j = 0; j < 4; ++j) {
      const sym = reel.getReelSymbol(j);
      rowList.push(sym);
    }
    gameController.savedReels.push(rowList);
  }
};

gameController.loadReels = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    for (let j = 0; j < 4; ++j) {
      reel.setReelSymbol(j, gameController.savedReels[i][j]);
    }
  }
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Platform Paused") {
      gameController.cancelAutoplay();
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (
      event.data === "Platform Popup Close" &&
      !gameController.platformPaused
    ) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      if (event.data !== "AutoplayController - cancel") {
        gameController.cancelAutoplay();
      }
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === "string") {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };
}

Reflex.addToUpdate(gameController.update);
messageBus.subscribe(
  "spinner:GameConfigEvent",
  gameController.onGameConfigEvent
);
messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:ReadyToStart", gameController.readyToStart);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.doPayWins);
messageBus.subscribe(
  "game:FeatureAnnounceEvent",
  gameController.onFeatureStart
);
messageBus.subscribe(
  "spinner:FreeSpinsStartEvent",
  gameController.onFreespinsStart
);
messageBus.subscribe(
  "spinner:FreeSpinsEndEventDead",
  gameController.onFreespinsEnd
);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe("platform:ReplayComplete", gameController.replayComplete);
messageBus.subscribe("hookComplete", gameController.hookComplete);
messageBus.subscribe("spinner:RespinDataEvent", gameController.onRespinData);

Reflex.registerEventHandler("layoutChange", gameController.onLayoutChange);
messageBus.subscribe("game:modal", gameController.onModal);
